/* Downscale photo to max 1600px, JPEG ~80 % */
export async function resizeImage(file, maxSize = 1600, quality = 0.8) {
    if (!file.type.startsWith("image/")) return file;
    const bitmap = await createBitmap(file);
    if (!bitmap) return file;
    const { width, height } = bitmap;
    const scale = Math.min(1, maxSize / Math.max(width, height));
    const w = Math.round(width * scale), h = Math.round(height * scale);
    const canvas = document.createElement("canvas");
    canvas.width = w; canvas.height = h;
    canvas.getContext("2d").drawImage(bitmap, 0, 0, w, h);
    if (bitmap.close) bitmap.close();
    const blob = await new Promise((res) => canvas.toBlob(res, "image/jpeg", quality));
    if (!blob) return file;
    const name = (file.name || "foto").replace(/\.[^.]+$/, "") + ".jpg";
    return new File([blob], name, { type: "image/jpeg", lastModified: Date.now() });
}

async function createBitmap(file) {
    try {
        if ("createImageBitmap" in window) return await createImageBitmap(file, { imageOrientation: "from-image" });
    } catch { /* fallback below */ }
    return new Promise((resolve) => {
        const url = URL.createObjectURL(file);
        const img = new Image();
        img.onload = () => { URL.revokeObjectURL(url); resolve(img); };
        img.onerror = () => { URL.revokeObjectURL(url); resolve(null); };
        img.src = url;
    });
}
